export default __webpack_public_path__ + "static/media/043-implode.5af2365d.svg";